module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-aoj_e-123bb84bbb03ed81fc5b29e8bde9dc08.jpg";